import { FormatConstants } from 'services/keyConstants';

export const getStatusTypes = (type) => {
  switch (type) {
    case FormatConstants.FINISHED_REGISTER_PRODUCT.FINISHED_PRODUCT_REGISTER:
      return {
        filteredData: {
          page: 1,
          totalPage: 1,
        },
        defaultOptionData: {
        }
      };
      break;

    // Default case if no matching type is found
    default:
      return {
        filteredData: {
        },
        defaultOptionData: {
        }
      };
  }
};
